import React from 'react';
import { ValueCache } from '@leverege/value-cache';
import PropTypes from 'prop-types';
import RcTree from 'rc-tree';
import Theme from "../Theme.js";
import NodeRendererWrapper from "./NodeRendererWrapper.js";
import IconRenderer from "./IconRenderer.js";
import NodeRenderer from "./NodeRenderer.js";
import SwitcherIcon from "./SwitcherIcon.js";
import DelegateFactory from "./DelegateFactory.js";
import DefaultNodeDelegate from "./DefaultNodeDelegate.js";
import { jsx as _jsx } from "react/jsx-runtime";
class Tree extends React.Component {
  static contextType = Theme.Context;
  static propTypes = {
    className: PropTypes.string,
    variant: PropTypes.string,
    data: PropTypes.any,
    nodeRenderer: PropTypes.any,
    iconRenderer: PropTypes.any,
    switcherIcon: PropTypes.any,
    delegateFactory: PropTypes.any
  };
  static defaultProps = {
    className: null,
    variant: null,
    data: [],
    nodeRenderer: NodeRenderer,
    iconRenderer: IconRenderer,
    switcherIcon: SwitcherIcon,
    delegateFactory: DelegateFactory
  };
  constructor(props) {
    super(props);
    this.rendererCache = new ValueCache();
  }
  onEvent = evt => {
    const {
      onEvent
    } = this.props;
    if (onEvent) {
      onEvent(evt);
    }
  };
  onSelect = (selectedKeys, evt) => {
    const {
      eventData,
      onSelect
    } = this.props;
    const {
      node,
      nativeEvent
    } = evt;
    if (onSelect && node) {
      onSelect({
        node,
        selectedKeys,
        value: node?.data,
        data: node?.eventData,
        listData: eventData,
        sourceEvent: nativeEvent,
        onSelect
      });
    }
  };
  getNodeRenderer = (nodeProps, nodeRenderer, preCmp, postCmp, iconRenderer, className, layout, selectedKeys) => {
    return NodeRendererWrapper({
      renderer: nodeRenderer,
      preCmp,
      postCmp,
      iconRenderer,
      nodeProps,
      className,
      layout,
      selectedKeys,
      onSelect: this.onSelect,
      onEvent: this.onEvent
    });
  };
  getTreeData = tree => {
    const {
      delegateFactory
    } = this.props;
    if (Array.isArray(tree)) {
      return tree.map(this.getTreeData);
    }
    const node = tree;
    const delegate = delegateFactory.create(node);
    return {
      key: delegate.getKey(node),
      title: delegate.getName(node),
      children: delegate.getChildren(node)?.map(this.getTreeData),
      data: delegate.getData(node),
      isLeaf: delegate.isLeaf(node),
      eventData: delegate.getEventData(node),
      canDelete: delegate.canDelete(node)
    };
  };
  render() {
    const theme = this.context;
    const {
      className,
      variant,
      data,
      onEvent,
      selectedKeys,
      layoutOptions,
      nodeProps,
      nodeRenderer,
      iconRenderer,
      switcherIcon,
      nodeClassName,
      nodeLayout,
      onSelect,
      preTitleComponent,
      postTitleComponent,
      ...rest
    } = this.props;
    const renderer = this.rendererCache.calc(this.getNodeRenderer, nodeProps, nodeRenderer, preTitleComponent, postTitleComponent, iconRenderer, nodeClassName, nodeLayout, selectedKeys);
    const treeData = this.getTreeData(data);
    return /*#__PURE__*/_jsx(RcTree, {
      selectedKeys: selectedKeys,
      treeClassName: theme.classes('Tree', 'tree', variant, className),
      treeData: treeData
      // disabled because its awful and receives no context
      ,
      titleRender: () => null,
      onSelect: this.onSelect,
      switcherIcon: switcherIcon,
      icon: renderer,
      ...rest
    });
  }
}
Tree.DefaultNodeDelegate = DefaultNodeDelegate;
Tree.DelegateFactory = DelegateFactory;
export default Tree;